module.exports = __webpack_public_path__ + "static/media/country-03.a6c0364c.png";